import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton, Tooltip } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../store/actions';
import { withRouter } from 'react-router-dom';
import * as TableActions from 'main/components/tableSort/store/actions';
import _ from 'lodash';
import TableCellTooltip from '../../../components/TableCellTooltip';
import * as courseActions from '../../course/store/actions';


const styles = theme => ({
	layoutRoot: {},
});

class WizardLessonList extends Component {

	constructor(props) {
		super(props);
	}

	getAddColumn = (row) => {
		if (this.props.Unscheduled) {
			const selected = this.props.mappedLessons.filter(l => l.lesson_id === row.original.lesson_id)[0]
			if (selected) {
				return null
			}
			return (
				<IconButton
					style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
					onClick={(ev) => {
						if (this.props.match.params.view_type === 'edit') {
							ev.stopPropagation();
							this.props.pushUnscheduledLessonOutsideBuilder(row.original)
						}
						else {
							ev.stopPropagation();
							this.props.pushUnscheduledLesson(row.original)
						}

					}}
				>
					<Icon>add</Icon>
				</IconButton>
			)
		}
		return (
			<div className="flex items-center">
				<Tooltip title="Detail">
					<IconButton
						style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
						onClick={(ev) => {
							ev.stopPropagation();
							this.props.selectLessonHub(row.original)
						}}
					>
						<Icon>add</Icon>
					</IconButton>
				</Tooltip>
			</div>
		)
	}

	render() {
		const { classes, lessonList, table_sort, table_filter, table_page_size, is_loaded } = this.props;
		const table_name = this.constructor.name;

		return (
			<ReactTable
				columns={[
					{
						Header: "Lesson Name",
						accessor: "LessonName",
						Cell: row => (
							<TableCellTooltip
								item={row.original.LessonName}
								chars={20}
							/>
						)
					},
					{
						Header: "Lesson Description",
						accessor: "LessonDescription",
						Cell: row => (
							<TableCellTooltip
								item={row.original.LessonDescription}
								chars={20}
							/>
						)
					},
					{
						Header: "Add",
						maxWidth: 150,
						Cell: row => this.getAddColumn(row)
					}
				]}
				data={lessonList}
				defaultPageSize={10}
				pageSize={table_page_size[table_name]}
				className="-striped -highlight"
				noDataText="No Lessons Found"
				defaultSorted={table_sort[table_name]}
				onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
				filterable={true}
				defaultFiltered={table_filter[table_name]}
				onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
				onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
			/>

		);
	}


}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setTableSort: TableActions.setTableSort,
		setTableFilter: TableActions.setTableFilter,
		setTablePageSize: TableActions.setTablePageSize,
		selectLessonHub: courseActions.selectLessonHub,
		pushUnscheduledLesson: courseActions.pushUnscheduledLesson,
		pushUnscheduledLessonOutsideBuilder: courseActions.pushUnscheduledLessonOutsideBuilder
	}, dispatch);
}

function mapStateToProps({ courseApp, auth, tableSort }) {
	return {
		table_sort: tableSort.table_sort,
		table_filter: tableSort.table_filter,
		table_page_size: tableSort.table_page_size,
		is_loaded: tableSort.is_loaded,
		auth,
	}
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(WizardLessonList)));


// WEBPACK FOOTER //
// src/main/content/course/builderComponents/WizardLessonList.js